import React from 'react';
import { PaperPlaneTilt } from '@phosphor-icons/react/dist/ssr/PaperPlaneTilt';
import { COLORS } from '../../../styles/UISystem';

/**
 * SendButton — paper plane icon for sending messages.
 * Used in chat input, name overlay, and contact overlay.
 *
 * @param {function} onClick - Click handler
 * @param {string} [type='button'] - Button type attribute
 */

const buttonStyle = {
  width: '40px',
  height: '40px',
  minWidth: '40px',
  minHeight: '40px',
  border: 'none',
  outline: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  backgroundColor: 'transparent',
  flexShrink: 0,
};

const SendButton = ({ onClick, type = 'button', ...rest }) => (
  <button type={type} onClick={onClick} style={buttonStyle} {...rest}>
    <PaperPlaneTilt size={24} color={COLORS.CHAT_SENT} weight="fill" />
  </button>
);

export { SendButton };
export default SendButton;
